export interface Bar {
  element: HTMLElement;
  /** Width is a percentage of a filled child — no canvas, no framework. */
  set(value: number, max: number, label?: string): void;
}

export function createBar(variant: "health" | "energy" | "experience"): Bar {
  const element = document.createElement("div");
  element.className = `hud-bar hud-bar--${variant}`;

  const fill = document.createElement("div");
  fill.className = "hud-bar-fill";

  const label = document.createElement("div");
  label.className = "hud-bar-label";

  element.append(fill, label);

  return {
    element,
    set: (value, max, text) => {
      const ratio = max > 0 ? Math.min(1, Math.max(0, value / max)) : 0;
      fill.style.width = `${ratio * 100}%`;
      label.textContent = text ?? `${Math.round(value)} / ${Math.round(max)}`;
    },
  };
}
